import {intlShape} from '@wallaby-ui/core';
import PropTypes from 'prop-types';
import * as React from 'react';
import {injectIntl} from 'react-intl';

import styles from './TextFormatter.less';
import baseTextFormatterParams from 'src/js/lib/raw_rendering/base_text_formatter_params';

class TextFormatter extends React.PureComponent {
  render() {
    const {intl} = this.props;
    const {formattedValue, hasValue, label, valueStyle} =
      baseTextFormatterParams(this.props, {intl});

    return hasValue ? (
      <div className={styles.dlTextFormatter} title={label}>
        <span className={styles.dlTextFormatterValue} style={valueStyle}>
          {formattedValue}
        </span>
      </div>
    ) : (
      ''
    );
  }
}

TextFormatter.displayName = 'TextFormatter';

/* eslint-disable react/no-unused-prop-types */
TextFormatter.propTypes = {
  intl: intlShape.isRequired,
  value: PropTypes.objectOf(PropTypes.any),
};

TextFormatter.defaultProps = {
  value: undefined,
};

export default injectIntl(TextFormatter);
